import React, { Component } from 'react'
import { connect } from "react-redux"
import { withTranslation } from 'react-i18next'
import Moment from 'moment'

import { bindActionCreators } from 'redux'
import { actions as employeeActions } from '../../../actions/employee'
import employeeService from '../../../services/Employee.service'

import AcceptAwardWizard from '../AcceptAwardWizard'
import { COMPONENT_IDS } from '../common/common'

import { Col, Row, View, Hr, Spacer } from '@amzn/stencil-react-components/layout'
import { Button } from '@amzn/stencil-react-components/button'
import { Card } from '@amzn/stencil-react-components/card'
import { H2, H3, Text } from '@amzn/stencil-react-components/text'
import { MessageBanner, MessageBannerType } from '@amzn/stencil-react-components/message-banner'

class UnacceptedStockAwards extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isAcceptAwardWizardVisible: false,
            award: null,
            selectedButton: null
        };
    }

    createCardDetailRow = (label, value) => {
      return (
        <Row gridGap="S100" alignItems="center">
          <Text>{label}</Text>
          <Text>{value}</Text>
        </Row>
      );
    }

    createUnacceptedAwardRow = (t, index, award, locale) => {
        const rsus = new Intl.NumberFormat(locale).format(award.shares_awarded);
        const buttonId = "unacceptedAward_" + index;
        const ariaLabel = "Review Award " + award.amazon_award_name;
        return (
            <>
              <Row gridGap="S400" alignItems="center" flexWrap="wrap">
                <Col gridGap="S300">
                  <Col gridGap="S100">
                    <H3 fontWeight="medium">{`${award.amazon_award_name} | ${award.amazon_award_id}`}</H3>
                    <Text>{t('UnacceptedStockAwards.AwardedOnLabel', {awarded_date: Moment(award.awarded_date).format('ll')})}</Text>
                    {this.createCardDetailRow(t('UnacceptedStockAwards.NextVestDate') + ":", award.next_vest_date ? Moment(award.next_vest_date).format('ll') : "N/A")}
                  </Col>
                </Col>
                <Spacer flex={1} />
                <Text fontSize="T400" fontWeight="bold">
                  {t("UnacceptedStockAwards.UnvestedRsuInfo", {
                    remaining_rsu: rsus
                  })}
                </Text>
                <Button id={buttonId} aria-label={ariaLabel} onClick={() => this.onUnacceptedAwardClick(award, buttonId)}>
                  {t("UnacceptedStockAwards.AcceptAwardLabel")}
                </Button>
              </Row>
              <Hr />
            </>
        );
    };

    onUnacceptedAwardClick = (award, button) => {
        this.setState({
            isAcceptAwardWizardVisible: true,
            award: award,
            selectedButton: button
        });
    };

    onAcceptAwardWizardClose = () => {
        this.setState({
            isAcceptAwardWizardVisible: false
        });
    };

    render() {
        const { t, unacceptedAwards, locale } = this.props;
        if (!(unacceptedAwards && unacceptedAwards.length > 0)) {
            return null;
        }

        return (
            <View>
                <Col gridGap="S300">
                    <H2 tabIndex="-1" id={COMPONENT_IDS.UnacceptedAward}>{t('UnacceptedStockAwards.Title')}</H2>
                    <MessageBanner type={MessageBannerType.Warning}>
                       {t('UnacceptedStockAwards.SubTitle')}
                    </MessageBanner>
                    {unacceptedAwards.map((award, index) => {
                        return this.createUnacceptedAwardRow(t, index, award, locale)
                    })}
                    {
                    /*
                        Doing so instead of <AcceptAwardWizard visible={this.state.isAcceptAwardWizardVisible}
                        so that new AcceptAwardWizard will be created every time isAcceptAwardWizardVisible changes and all its state will be reset 
                        instead of reusing the previous state from the updated AcceptAwardWizard
                    */
                        this.state.isAcceptAwardWizardVisible && 
                            <AcceptAwardWizard
                                award={this.state.award}
                                prevFocusItem={this.state.selectedButton}
                                onWizardClose={this.onAcceptAwardWizardClose}
                            />
                    }
                </Col>
            </View>
        );
    }

}

const mapState = state => ({
  unacceptedAwards: employeeService.getUnacceptedRSUs(state.employee.awards),
  locale: state.employee.language
});

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
  }
});

export default connect(mapState, mapDispatchToProps)(withTranslation('translationsV2')(UnacceptedStockAwards));
